import axios from 'axios';
import { mapProductCatalogtDtoToModel } from './mapper';

import type { ProductCatalog, ProductCatalogDto } from './types';

/**
 * @deprecated
 * If you are looking for a react hook implementation for the product catalog
 * api, use the `useProductCatalog` hook by importing it from `@hotjar/product-catalog`
 * package.
 *
 * import { useProductCatalog } from '@hotjar/product-catalog';
 *
 * In the event you are only looking for the fetch method, import
 * the V3 product catalog implementation from `@hotjar/product-catalog`.
 *
 * import { getProductCatalog } from '@hotjar/product-catalog';
 *
 */
export async function getProductCatalog(): Promise<ProductCatalog> {
  const response = await axios.get<ProductCatalogDto>('/api/v2/product_catalog');

  return mapProductCatalogtDtoToModel(response.data);
}
